import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUpdatedOrderInfo } from "../../Utilities";
import {
  updateExchangeSettingsDetails,
  updateRefundSettingsDetails,
  setProductDetails,
  updateOtherSettings,
  updatePaymentSettings,
} from "../../redux/slices";
import {
  exchangeSettingsActionTypes,
  refundSettingsActionTypes,
  productActionTypes,
  otherSettingsActionTypes,
  paymentSettingTypes,
} from "../../redux/utils";
import { useHardCode, useAPI } from "../../hooks";
import { useAppContext } from "../../contexts";
import { Toast } from "..";
export const RazorPay = ({
  api_key,
  amount,
  payment_description,
  image,
  collectPaymentThrough,
  store_name,
  route_name,
  notes,
  razorpay_order_id,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoader, setIsLoader] = useState(false);
  const refundSettingsState = useSelector((state) => state.refundSettings);
  const storeConfigState = useSelector((state) => state.storeSettings);
  const productDetailsState = useSelector((state) => state.productDetails);
  const exchangeSettingsState = useSelector((state) => state.exchangeSettings);
  const otherSettingsState = useSelector((state) => state.otherSettings);
  const paymentSettingsState = useSelector((state) => state.paymentSettings);
  const selectedProductDetailsState = useSelector(
    (state) => state.selectedProductDetails
  );
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME } = useHardCode();
  const {
    SUBMIT_RETURN_REQUEST_API,
    RETURN_SUBMIT_API,
    EXCHANGE_RAZORPAY_PAYMENT_API,
    EXCHANGE_SUBMIT_API
  } = useAPI();
  const {
    isInternalServerError,
    setIsInternalServerError,
    setIsPaymentCompleted,
    setIsLoadingPayment,
    setRazorPayPaymentSuccess,
  } = useAppContext();

  const FINAL_API_CALL_RETURN =
    storeConfigState.platform === "shopify"
      ? SUBMIT_RETURN_REQUEST_API
      : RETURN_SUBMIT_API;

  const FINAL_API_CALL_EXCHANGE = EXCHANGE_RAZORPAY_PAYMENT_API

  const options = {
    key: api_key,
    // amount: amount,
    order_id:razorpay_order_id,
    name: store_name,
    description: payment_description,
    image: image,
    notes: notes,
    handler: function (rp_response) {
      if (rp_response?.razorpay_payment_id) {
        if (route_name === "return") {
          (async () => {
            setIsLoader(true);
            if (
              refundSettingsState.refundReviewRoute === "STORE_CREDIT" ||
              refundSettingsState.refundReviewRoute === "ORIGINAL_PAYMENT"
            ) {
              const maxRetries = 3;
              let delayTime = 1000; //time in ms
              const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
              for (let attempt = 0; attempt < maxRetries; attempt++) {
                try {
                const response = await axios.post(FINAL_API_CALL_EXCHANGE, {
                  ran: otherSettingsState.ran,
                    razorpay_payment_id: rp_response?.razorpay_payment_id,
                    collect_payment_through : collectPaymentThrough,
                    store_name: storeConfigState.storeUniqueID,
                    id: paymentSettingsState.paymentID,
                    amount: refundSettingsState.razorPayObject.payment_amount,
                });
  
                if (response) {
                  dispatch(
                    updatePaymentSettings({
                      key: paymentSettingTypes.UPDATE_PAYMENT_REQUIRED,
                      value: false,
                    })
                  );
                  dispatch(
                    updateRefundSettingsDetails({
                      key: refundSettingsActionTypes.UPDATE_COLLECT_FROM_RAZORPAY,
                      value: false,
                    })
                  );
                  setRazorPayPaymentSuccess(true);
                  setIsLoadingPayment(false);
                  setIsPaymentCompleted(true);
                    const isShowRAN =
                      SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.steve_maiden
                        ? ""
                        : `RAN# ${otherSettingsState.ran}`;
                    if (
                      refundSettingsState.refundReviewRoute === "ORIGINAL_PAYMENT"
                    ) {
                      dispatch(
                        updateRefundSettingsDetails({
                          key: refundSettingsActionTypes.UPDATE_THANKYOU_DESCRIPTION,
                          value: storeConfigState?.themeConfig
                            ?.return_submission_original_payment_left_content
                            ? storeConfigState?.themeConfig
                                ?.return_submission_original_payment_left_content
                            : `${storeConfigState?.themeConfig?.your_return_request} ${isShowRAN} ${storeConfigState?.themeConfig?.has_been_submitted_original_payment_method}`,
                        })
                      );
                    } else if (
                      refundSettingsState.refundReviewRoute === "STORE_CREDIT"
                    ) {
                      dispatch(
                        updateRefundSettingsDetails({
                          key: refundSettingsActionTypes.UPDATE_THANKYOU_HEADING,
                          value:
                            storeConfigState?.themeConfig
                              ?.return_submission_store_credit_left_title,
                        })
                      );

                      dispatch(
                        updateRefundSettingsDetails({
                          key: refundSettingsActionTypes.UPDATE_THANKYOU_DESCRIPTION,
                          value: storeConfigState?.themeConfig
                            ?.return_submission_store_credit_left_content
                            ? storeConfigState?.themeConfig
                                ?.return_submission_store_credit_left_content
                            : `${storeConfigState?.themeConfig?.your_return_request} ${isShowRAN} ${storeConfigState?.themeConfig?.has_been_submitted_original_payment_method}`,
                        })
                      );

                      dispatch(
                        updateRefundSettingsDetails({
                          key: refundSettingsActionTypes.UPDATE_THANKYOU_CARD_HEADING,
                          value:
                            storeConfigState?.themeConfig
                              ?.return_submission_store_credit_right_card_title,
                        })
                      );

                      dispatch(
                        updateRefundSettingsDetails({
                          key: refundSettingsActionTypes.UPDATE_KEEP_THE_ITEM_AMOUNT_DESCRIPTION,
                          value:
                            storeConfigState?.themeConfig
                              ?.return_submission_store_credit_right_card_subtitle,
                        })
                      );
                    }

                    // Update product list
                    const updatedOrderInfo = getUpdatedOrderInfo(
                      productDetailsState,
                      selectedProductDetailsState
                    );

                    // Update the product list on Redux
                    dispatch(
                      setProductDetails({
                        key: productActionTypes.SET_ORDER_INFO,
                        value: updatedOrderInfo,
                      })
                    );
                    setIsLoader(false);
                    navigate("/ThankYou");
                    break;
                  }
                } catch (error) {
                  setIsInternalServerError(true);
                  setIsLoader(false);
                  // If it's the last attempt, rethrow the error

                  if (attempt === maxRetries - 1) {
                    if (error?.response?.status === 500) {
                      setIsInternalServerError(true);
                    }
                    console.log('Reached maximum retries.');
                }
                  else {
                    // Wait for the delay time before retrying
                    await delay(delayTime);
                    delayTime += 1000;
                  }
                }
              }
            } else if (refundReturnID === "3") {
              navigate("/RefundOptions");
              dispatch(
                updateExchangeSettingsDetails({
                  key: exchangeSettingsActionTypes.UPDATE_NAVIGATE_BACK,
                  value: "/refund",
                })
              );
            }
          })();
        } else if (route_name === "exchange") {
          (async () => {
            setIsLoader(true);
            const maxRetries = 3;
            let delayTime = 1000; //time in ms
            const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
            for (let attempt = 0; attempt < maxRetries; attempt++) {
              try {
                const response = await axios.post(FINAL_API_CALL_EXCHANGE, {
                  ran: otherSettingsState.ran,
                  razorpay_payment_id: rp_response?.razorpay_payment_id,
                  collect_payment_through:collectPaymentThrough,
                  store_name: storeConfigState.storeUniqueID,
                  id: paymentSettingsState.paymentID,
                  amount: refundSettingsState.razorPayObject.payment_amount,
                });
  
                if (response) {
                  dispatch(
                    updatePaymentSettings({
                      key: paymentSettingTypes.UPDATE_PAYMENT_REQUIRED,
                      value: false,
                    })
                  );
                  dispatch(
                    updateRefundSettingsDetails({
                      key: refundSettingsActionTypes.UPDATE_COLLECT_FROM_RAZORPAY,
                      value: false,
                    })
                  );
                  setRazorPayPaymentSuccess(true);
                  setIsLoadingPayment(false);
                  setIsPaymentCompleted(true);
                }
                break;
              } 
              catch (error) {
                // If it's the last attempt, rethrow the error
                setIsLoader(false);
                if (attempt === maxRetries - 1) {
                  if (error?.response?.status === 500) {
                    setIsInternalServerError(true);
                  }
                  console.log('Reached maximum retries.');
                }
                else {                  
                  // Wait for the delay time before retrying
                  await delay(delayTime);
                  delayTime += 1000;
                }

              }
            }
          })();
        }
      } else {
        setIsInternalServerError(true);
      }
    },
    prefill: {
      name: productDetailsState.customerName,
      contact: productDetailsState.customerContact,
      email: productDetailsState.customerEmail,
    },
    notes: {
      address: "",
    },
    theme: {
      color: "#F37254",
      hide_topbar: false,
    },
  };

  const openPayModal = (options) => {
    let rzp1 = new window.Razorpay(options);
    rzp1.open();
  };
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      {isInternalServerError ? (
        <Toast type="error" />
      ) : (
        <button
          className="saara_custom_btn btn__submit"
          style={{ marginLeft: "10px" }}
          onClick={() => openPayModal(options)}
        >
          {isLoader ? (
            <div
              className="saara-spinner-border saara-spinner-border-sm"
              role="status"
            >
              <span className="saara-visually-hidden"></span>
            </div>
          ) : (
            storeConfigState?.themeConfig
              ?.exchange_payment_page_pay_now_button_label
          )}
        </button>
      )}
    </>
  );
};
